import React from "react";
import { Reveal } from "@/components/landing/kit";
import { ASSETS } from "@/lib/site-data";

const BrandWall = () => (
  <section data-testid="brand-wall" className="border-b border-[#E5E8F0] bg-white py-16 sm:py-20">
    <div className="mx-auto max-w-6xl px-5 sm:px-6 lg:px-8">
      <p className="text-center font-heading text-xs font-bold uppercase tracking-[0.3em] text-[#6B7385]">
        Approved best-selling brands we source &amp; sell
      </p>

      <Reveal className="mt-10">
        <div className="relative overflow-hidden rounded-3xl border border-[#E5E8F0] bg-[#F7F9FD] px-4 py-8 sm:px-10 sm:py-12">
          <img
            src={ASSETS.brandsImage}
            alt="Best-selling brands we source and sell across Amazon, Walmart, eBay, Shopify and Temu"
            className="relative mx-auto w-full max-w-4xl"
            style={{ filter: "grayscale(1) opacity(0.75)" }}
          />
        </div>
      </Reveal>
    </div>
  </section>
);

export default BrandWall;
